import React from "react";
import "./contact.scss";

function Paragraf(props) {
  return <p className="paragraf completed about">{props.title}</p>;
}

export default Paragraf;
